import React from 'react';
import SellerInfoContainer from './components/container';

const SellerInfo = props => <SellerInfoContainer className="ui-seller-info" {...props} />;

export default SellerInfo;
